import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { generateDuplicateReport, cleanupDuplicateImages } from '../../utils/duplicateImageUtils';

const DuplicateImageCleanup = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [duplicates, setDuplicates] = useState([]);
  const [cleanedCount, setCleanedCount] = useState(0);

  const checkDuplicates = async () => {
    if (!currentUser) return;
    
    setLoading(true);
    try {
      const duplicateReport = await generateDuplicateReport(currentUser.uid);
      setDuplicates(duplicateReport);
      console.log('Duplicate images found:', duplicateReport);
    } catch (error) {
      console.error('Error checking duplicates:', error);
      alert('เกิดข้อผิดพลาดในการตรวจสอบรูปซ้ำ');
    } finally {
      setLoading(false);
    }
  };

  const cleanupDuplicates = async () => {
    if (!currentUser) return;
    
    if (duplicates.length === 0) {
      alert('ไม่มีรูปภาพซ้ำที่ต้องทำความสะอาด');
      return;
    }
    
    const confirmed = window.confirm(
      `พบรูปภาพซ้ำ ${duplicates.length} รูป ต้องการลบออกหรือไม่?`
    );
    
    if (!confirmed) return;
    
    setLoading(true);
    try {
      const cleanedCount = await cleanupDuplicateImages(currentUser.uid);
      setCleanedCount(cleanedCount);
      setDuplicates([]);
      alert(`ทำความสะอาดรูปภาพซ้ำเรียบร้อยแล้ว ลบออก ${cleanedCount} รูป`);
    } catch (error) {
      console.error('Error cleaning up duplicates:', error);
      alert('เกิดข้อผิดพลาดในการทำความสะอาด');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-lg font-semibold mb-4">🧹 ทำความสะอาดรูปภาพซ้ำ</h3>
      
      <div className="space-y-4">
        <div className="flex gap-2">
          <button
            onClick={checkDuplicates}
            disabled={loading}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
          >
            {loading ? 'กำลังตรวจสอบ...' : '🔍 ตรวจสอบรูปซ้ำ'}
          </button>
          
          {duplicates.length > 0 && (
            <button
              onClick={cleanupDuplicates}
              disabled={loading}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
            >
              {loading ? 'กำลังทำความสะอาด...' : '🗑️ ลบรูปซ้ำ'}
            </button>
          )}
        </div>

        {duplicates.length > 0 && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h4 className="font-semibold text-yellow-800 mb-2">
              พบรูปภาพซ้ำ {duplicates.length} รูป
            </h4>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {duplicates.map((duplicate, index) => (
                <div key={index} className="text-sm text-yellow-700">
                  <div className="flex items-center gap-2">
                    <span>📷</span>
                    <span className="font-medium">{duplicate.originalName}</span>
                    <span className="text-xs bg-yellow-200 px-2 py-1 rounded">
                      {duplicate.status}
                    </span>
                  </div>
                  <div className="text-xs text-yellow-600 ml-6">
                    ขนาด: {(duplicate.originalSize / 1024 / 1024).toFixed(2)} MB
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {cleanedCount > 0 && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-semibold text-green-800 mb-2">
              ✅ ทำความสะอาดเรียบร้อยแล้ว
            </h4>
            <p className="text-sm text-green-700">
              ลบรูปภาพซ้ำออกแล้ว {cleanedCount} รูป
            </p>
          </div>
        )}

        <div className="text-xs text-gray-500">
          <p>• ระบบจะตรวจสอบรูปซ้ำโดยใช้ hash ของไฟล์และขนาดไฟล์</p>
          <p>• รูปที่ซ้ำจะถูกลบออกจากฐานข้อมูล</p>
          <p>• การทำความสะอาดจะไม่ส่งผลต่อรูปที่อนุมัติแล้ว</p>
        </div>
      </div>
    </div>
  );
};

export default DuplicateImageCleanup;









